import React, { Component } from 'react'
import { connect } from 'react-redux'
import { formatCurrency, windowResize } from '../utils'
import { getDraws, getEvents } from "../actions/eventsAction"
import { getMessages } from '../actions/messageActions'
import BetBar from '../components/BetBar'

class PrizesPage extends Component {

  componentDidUpdate(prevProps, prevState) {
    if (prevProps !== this.props) {
      windowResize();
    }
  }

  componentDidMount() {
    if (this.props.gamesList == '') {
      this.props.getEvents();
      this.props.getDraws();
    }
    document.title = "Prizes";
    windowResize();
  }

  render() {

    const jackpots = []
    let gameslistKeys = Object.keys(this.props.gamesList);
    for (let j = 0; j < gameslistKeys.length; j++) {
      jackpots.push({
        name: gameslistKeys[j], link: gameslistKeys[j].toLowerCase()
      })
    }
    if(jackpots.length==0){
      jackpots.push({
        name: "Multi-Market", link: "multi-market"
      })
    }
    const jackpot = 'R10 000';//this.props.gamesList && formatCurrency(this.props.gamesList[jackpots[0].name][0]['jackpot']) || formatCurrency('10000')

    return (
      <div>
        <BetBar jackpot={jackpots[0]} />
        <p className="text-center py-3">Each day there will be {jackpot} in cash up for grabs. The Jackpot resets every day and the prize will be shared equally among all qualifying winners.</p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    messages: state.messageReducer.messages,
    gamesList: state.eventsReducer.gamesList
  }
}

export default connect(mapStateToProps,{getMessages,getDraws,getEvents})(PrizesPage);




// WEBPACK FOOTER //
// ./pages/prizesPage.js